import Axios from "axios";
var MemberBalanceManageService = (function () {
    function MemberBalanceManageService() {
    }
    MemberBalanceManageService.prototype.getList = function (params) {
        return Axios.get("supplierclientapi/shop_finance/summary", { params: params });
    };
    MemberBalanceManageService.prototype.getTypeList = function () {
        return Axios.get("supplierclientapi/shop_finance/type_log_list");
    };
    MemberBalanceManageService.prototype.getDetail = function (params) {
        return Axios.get("/supplierclientapi/shop_finance/to_shop_finance_log", { params: params });
    };
    MemberBalanceManageService.prototype.exportList = function (params) {
        return Axios.post("/supplierclientapi/shop_finance/to_shop_finance_log_export", { params: params });
    };
    MemberBalanceManageService.createInstance = function () {
        MemberBalanceManageService.getInstance();
    };
    MemberBalanceManageService.getInstance = function () {
        this._instance = new this();
        return this._instance;
    };
    return MemberBalanceManageService;
}());
export default MemberBalanceManageService;
